import createDuck from 'lib/ducks/remoteDuck'
import Products from 'lib/api/products'

export default createDuck({
  namespace: 'content',
  store: 'products',
  fetchCallback: (options) => Products.getList(options),
})
